<template>
    <div class="envLine"></div>
</template>

<script>
export default {
    name: 'envLine',
    props: {
        title: String,
        series: {
            type: Array,
            default: () => [] // [{ name: '传感器1', data: [{ t: '12:00', v: 25 }, ...] }]
        }
    },
    data() {
        return { myChart: null }
    },
    watch: {
        series: {
            deep: true,
            handler() { this.render() }
        }
    },
    methods: {
        render() {
            if (!this.myChart) this.myChart = this.$echarts(this.$el)
            const x = (this.series[0]?.data || []).map(p => p.t)
            // 为三组传感器定义不同的颜色
            const colors = ['#00CCFF', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4']
            const s = this.series.map((s, index) => {
                return {
                    name: s.name,
                    type: 'line',
                    symbol: 'none',
                    smooth: true,
                    data: s.data.map(p => p.v),
                    lineStyle: { 
                        width: 1.5,
                        color: colors[index] || colors[0]
                    },
                    itemStyle: {
                        color: colors[index] || colors[0]
                    }
                }
            })
            const option = {
                title: { text: this.title, left: 8, top: 4, textStyle: { color: '#fff', fontSize: 12 } },
                grid: { top: 28, bottom: 20, left: 28, right: 10 },
                tooltip: { trigger: 'axis', backgroundColor: '#11367a', textStyle: { color: '#6dd0e3', fontSize: 10 } },
                legend: { right: 8, top: 4, textStyle: { color: '#5CB1C1', fontSize: 10 }, itemWidth: 8, itemHeight: 8 },
                xAxis: { type: 'category', data: x, axisLabel: { color: '#61B9C8', fontSize: 10 }, axisLine: { lineStyle: { color: '#122C49' } } },
                yAxis: { type: 'value', axisLabel: { color: '#61B9C8', fontSize: 10 }, splitLine: { show: false }, axisLine: { lineStyle: { color: '#122C49' } } },
                series: s
            }
            this.myChart.clear()
            this.myChart.resize()
            this.myChart.setOption(option)
        }
    },
    mounted() { this.render() }
}
</script>

<style lang="less" scoped>
.envLine { height: 100%; width: 100%; }
</style>


